import { Box, Flex, Heading, Text } from 'rebass';
import tools from '../../tools';
import ToolItem from './ToolItem';
import LinksRow from './LinksRow';
import DayNightToggle from './DayNightToggle';
import { styles } from './homeStyles';

const Home = ({ night, setNight }) => {
  return (
    <Box maxWidth="1024px" mx="auto" py={6} px={[3, 4, 0]} style={styles.container}>
      <Flex
        minHeight="80vh"
        flexDirection="column"
        alignItems="flex-start"
        justifyContent="flex-start"
        textAlign="left"
      >
        <Box width="100%" display="flex" justifyContent="flex-end" mb={2}>
          <DayNightToggle night={night} setNight={setNight} />
        </Box>
        <Heading
          as="h1"
          fontSize={[4, 5, 6]}
          mb={1}
          color={night ? '#f5f5f5' : '#222'}
          style={styles.heroHeading}
        >
          superus8r
        </Heading>
        <Text 
          fontSize={[1, 2]} 
          color="gray" mb={4}
          style={styles.subtitle}
        >
          Mobile App Developer
        </Text>

        <LinksRow night={night} />

        <Box maxWidth={['100%', '420px']} width="100%" mt={2} style={styles.toolsCard(night)}>
          <Heading
            as="h2"
            fontSize={[2, 3]}
            mb={3}
            color="text"
            fontFamily="Menlo, ui-monospace, monospace"
            sx={{ textAlign: 'left' }}
          >
            Tools
          </Heading>
          {tools.map((tool) => (
            <ToolItem key={tool.link} {...tool} night={night} />
          ))}
        </Box>
      </Flex>
    </Box>
  );
};

export default Home;
